import { DeliveryDescription } from '../../module/types/deliverySchema';
import { WrapperDeliveryBlock } from './WrapperDeliveryBlock';
import { Htag } from '@ui-kit/Htag';

export const DeliveryPickup = ({ description, name }: DeliveryDescription) => {
  return (
    <>
      <Htag tag={'h3'}>{name}</Htag>
      <WrapperDeliveryBlock>
        <div dangerouslySetInnerHTML={{ __html: description || '' }} />
      </WrapperDeliveryBlock>
    </>
  );
};
